export default __webpack_public_path__ + "static/media/flag-be.a51efc77.svg";